import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/file.svg` */
export const FileSolidIcon = createTripletGlyphIcon('FileSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.62244 5.26367C7.62252 6.1184 8.31555 6.81159 9.17029 6.81348L13.3099 6.82031V12.8203C13.3097 13.8325 12.4892 14.6531 11.4769 14.6533H4.52283C3.51059 14.6531 2.69004 13.8325 2.68982 12.8203V3.18066C2.68991 2.16833 3.5105 1.34686 4.52283 1.34668H7.62341L7.62244 5.26367Z"
        fill="currentColor"
      />
      <path
        d="M8.72302 1.38184C9.04673 1.44537 9.34996 1.59462 9.59802 1.81836L11.4906 3.52637L12.6888 4.58203C13.0239 4.87732 13.2353 5.28308 13.2924 5.7207L9.17224 5.71387C8.92422 5.71316 8.72303 5.51174 8.72302 5.26367V1.38184Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.64453 5.9209C8.64456 6.84458 9.39274 7.59459 10.3164 7.59668L14.9619 7.60547V14.4219C14.9619 15.5537 14.0438 16.4711 12.9121 16.4717H5.08887C3.95668 16.4717 3.03906 15.5541 3.03906 14.4219V3.57715C3.03954 2.44544 3.95705 1.52744 5.08887 1.52734H8.64551L8.64453 5.9209Z"
        fill="currentColor"
      />
      <path
        d="M9.74512 1.55469C10.1319 1.61751 10.4959 1.78929 10.79 2.05469L12.9189 3.97656L14.2666 5.16309C14.6586 5.50839 14.9012 5.98963 14.9512 6.50488L10.3184 6.49609C10.0015 6.49518 9.74513 6.23786 9.74512 5.9209V1.55469Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4707 6.84839C11.4706 8.01939 12.4199 8.97014 13.5908 8.97046L19.5391 8.96948V20.9998C19.5391 21.7566 18.9257 22.3707 18.1689 22.3708H5.83105C5.07429 22.3707 4.46094 21.7566 4.46094 20.9998V3.00073C4.46094 2.24393 5.07428 1.63081 5.83105 1.63062L11.4707 1.62964V6.84839Z"
        fill="currentColor"
      />
      <path
        d="M12.9707 1.63745C13.2744 1.66938 13.5601 1.8019 13.7812 2.01636L16.9541 5.09351L19.1113 7.13647C19.2146 7.23428 19.2997 7.34738 19.3672 7.46948L13.5908 7.47046C13.2484 7.47014 12.9707 7.19092 12.9707 6.84839V1.63745Z"
        fill="currentColor"
      />
    </svg>
  ),
});
